import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { CustomSelect } from '../../../UsersList/components/CustomSelect';
import { jobStatusOptions } from '../../shared/constants';
import { userDaSubProfessions } from '../../../../../constants';
import debounceHook from '../../../../commonComponents/debounceHook';

export const Filters = ({ filters, handleFilterChanged }) => {
  const allProfessions = useSelector((state) => state.jobs.allProfessions);
  const allMetadata = useSelector((state) => state.users.allMetadata);

  const [searchText, setSearchText] = useState(filters?.searchText || '');
  const debouncedSearchText = debounceHook(searchText, 1000);

  useEffect(() => {
    handleFilterChanged('jobTitle', searchText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchText]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <p>Listing Name:</p>
        <input
          style={{
            paddingLeft: '8px',
            width: 250,
            height: 32,
          }}
          placeholder="Search by listing name"
          value={searchText}
          onChange={(event) => {
            setSearchText(event.target.value);
          }}
        />
      </div>
      
      <CustomSelect
        key="recruiter"
        id="recruiterEmail"
        label="Recruiter"
        options={[
          { code: '', name: 'All' },
          ...(allMetadata?.permanentRecruitersEmail || []).map((recruiterEmail) => ({
            code: recruiterEmail,
            name: recruiterEmail,
          })),
        ]}
        value={filters?.recruiterEmail || ''}
        onChange={handleFilterChanged}
      />

      <CustomSelect
        key="profession"
        id="professionType"
        label="Profession"
        options={[
          { code: '', name: 'All' },
          ...(allProfessions || []),
          ...(userDaSubProfessions || []),
        ]}
        value={filters?.professionType || ''}
        onChange={handleFilterChanged}
      />

      <CustomSelect
        key="status"
        id="status"
        label="Status"
        options={[{ code: '', name: 'All' }, ...jobStatusOptions].map((status) => ({
          code: status.code,
          name: status.name,
        }))}
        value={filters?.status || ''}
        onChange={handleFilterChanged}
      />
    </div>
  );
};
